import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';

export type PhotoTypeItem = {
    id: number;
    code: string;
    displayName: string;
};

export type PhotoTypeListResponse = {
    items: PhotoTypeItem[];
};

const pickItems = (raw: Record<string, unknown>): PhotoTypeItem[] => {
    const items = (raw.items ?? raw.Items ?? []) as Record<string, unknown>[];
    return items.map((item) => ({
        id: Number(item.id ?? item.Id ?? 0),
        code: String(item.code ?? item.Code ?? ''),
        displayName: String(item.displayName ?? item.DisplayName ?? ''),
    }));
};

const GetPhotoTypes = async (): Promise<PhotoTypeListResponse> => {
    const raw = (await request({
        url: ApiURL.Query.StudioQueryURLs.RawImageUploadQueryURL.GetPhotoTypes,
        method: RequestType.GET,
    })) as Record<string, unknown>;

    return { items: pickItems(raw) };
};

export const RawImageUploadQuery = {
    GetPhotoTypes,
};
